import {ISenderId} from '../core/_model'

type Props = {
  sender: ISenderId
}

const SenderCell = ({sender}: Props) => {
  const {text, color} = {
    text: sender.branded === 2 ? 'P2P' : 'A2P',
    color: sender.branded === 2 ? 'success' : 'primary',
  }

  return (
    <>
      <span className='d-block'>{sender.sender}</span>
      <span className={`badge badge-light-${color}`}>{text}</span>
    </>
  )
}

export default SenderCell
